import classNames from 'classnames';
import React from 'react';

import { Avatar } from '@vyaguta/vyaguta-ui';

import { getEmpImageUrl } from 'utils/string';

import type {
  GlobalRatingItem,
  SelectedSkillActionItem,
  SkillPillActionType,
  SkillRatingSelectorSkill,
  SkillRatingSelectorUser,
} from '../types';

type DispatcherPayload = { id: number | string; rating: number } | number | string;

type Props = {
  skill: SkillRatingSelectorSkill;
  rating: number | null;
  setRating: (value: number | null) => void;
  showAvatar?: boolean;
  skillRatingScale: GlobalRatingItem[];
  disabledRating?: number | null;
  loggedUser?: SkillRatingSelectorUser;
  dispatcherCallback?: (payload: DispatcherPayload, type: SkillPillActionType) => void;
  selectedSkills?: SelectedSkillActionItem[];
  showDescription?: boolean;
};

const SkillRatingSelector: React.FC<Props> = ({
  skill,
  rating,
  setRating,
  showAvatar,
  skillRatingScale,
  disabledRating,
  loggedUser,
  dispatcherCallback,
  selectedSkills,
  showDescription = true,
}) => {
  const handleRatingClick = (selectedRating: GlobalRatingItem) => {
    if (selectedSkills && dispatcherCallback && skill.id != null) {
      const isIdIncluded = selectedSkills.some((item) => item.id === skill.id);

      if (isIdIncluded && selectedRating.rating === rating) {
        setRating(null);
        dispatcherCallback(skill.id, 'remove');
      } else {
        setRating(selectedRating.rating);
        dispatcherCallback({ id: skill.id, rating: selectedRating.rating }, 'add');
      }
    } else if (selectedRating.rating === rating) {
      setRating(null);
    } else if (selectedRating.rating !== disabledRating) {
      setRating(selectedRating.rating);
    }
  };

  return (
    <div className="skill-rate-selector">
      {showDescription && skill.description && <div className="selector-description">{skill.description}</div>}
      <div className="skill-rate-selector__btn-container">
        {skillRatingScale.map((ratingScale) => (
          <div
            key={ratingScale.rating}
            className={classNames('rating-btn flex-1', {
              'rating-btn--selected': ratingScale.rating === rating && !showAvatar,
              'rating-btn--non-selected': ratingScale.rating !== rating && ratingScale.rating !== disabledRating,
              'rating-btn--selected-green': ratingScale.rating === rating && showAvatar,
              'rating-btn--disabled': ratingScale.rating === disabledRating,
            })}
            onClick={() => handleRatingClick(ratingScale)}
          >
            <div className="rating-btn__top-container">
              <div className="scale">{ratingScale.rating}</div>
              {ratingScale.rating === rating && loggedUser?.empId && (
                <div className="avatar-container">
                  <div className="avatar">
                    <Avatar image={getEmpImageUrl(loggedUser.empId)} size="extraSmall" />
                  </div>
                </div>
              )}
            </div>
            <div className="description">{ratingScale.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillRatingSelector;
